module.exports = __webpack_public_path__ + "static/img/newsd.e377929.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/newsd.png
// module id = ouod
// module chunks = 45